/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum FinnairPhoneType {
  MOBILE = 'MOBILE',
  LANDLINE = 'LANDLINE',
  EMERGENCY = 'EMERGENCY'
}

